// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__A6Tcb","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3Uri9"};